import React from 'react';
import { node, oneOf, oneOfType, string } from 'prop-types';

import { BTN_SIZE_PROPS } from '../constants';
import { normalizeIcon } from '../helpers';
import { styBtnIcon } from '../style';

const Icon = ({ icon, size }) => {
  const styIconProps = { size };

  return <span className={styBtnIcon(styIconProps)}>{icon && normalizeIcon(icon)}</span>;
};

Icon.propTypes = {
  icon: oneOfType([node, string]),
  size: oneOf(BTN_SIZE_PROPS),
};

Icon.defaultProps = {
  icon: null,
  size: 'sm',
};

export default Icon;
